import { Switch, SwitchProps } from '@mui/material';
import styles from './StyledSwitch.module.scss';

export type StyledSwitchProps = {} & SwitchProps;

export const StyledSwitch = (props: StyledSwitchProps) => {
  return <Switch {...props} className={styles.styledSwitch} />;
};
